<!-- Расход в блоке связанных записей, просмотр сохраняет текущую форму -->
<template>
  <BaseRelatedRecordCard :title="title" :subtitle="subtitle" icon="payment"
    :to="{ name: 'Expenses', query: { expense_id: expense.id } }"
    :removable="removable" :disabled="disabled" :remove-title="'Убрать связь с расходом №' + expense.id" @remove="$emit('remove')"
    :view-title="'Открыть расход №' + expense.id + ' в новой вкладке'" />
</template>
<script>
import { formatBigNumber } from "@/utils/numberUtils";
import { formatDateAndTimeLocal } from "@/utils/dateUtils";
export default {
  name: "ExpenseRelatedCard",
  props: { expense: { type: Object, required: true }, removable: Boolean, disabled: Boolean },
  emits: ["remove"],
  computed: {
    title() {
      return [this.expense.expense_category?.name || "Расход", formatBigNumber(this.expense.amount) + " ₽"].join(" · ");
    },
    subtitle() {
      return ["№" + this.expense.id, this.expense.spent_at ? formatDateAndTimeLocal(this.expense.spent_at) : null,
        this.expense.payment_source?.name, this.expense.spender?.initials, this.expense.comment].filter(Boolean).join(" · ");
    },
  },
};
</script>
